import { User } from "./User";

export class DataMessage {
    id : number;
    user : User;
    creationDate : Date;
    email : string;
    question : string;
    nid : string;
    typeEffect :string;
    
}